import { render, staticRenderFns } from "./PreviewProgramModal.vue?vue&type=template&id=160ca253"
import script from "./PreviewProgramModal.vue?vue&type=script&lang=js"
export * from "./PreviewProgramModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports